/* app/js/src/components/user-branding/user-branding.component.scss */
:host {
  width: 100%;
  height: 100%;
  background-color: #f1f3f4;
}
.container {
  width: 100%;
  height: 100%;
  text-align: center;
}
.container .inner {
  margin: 0 auto;
  width: 80%;
  height: 100%;
}
/*# sourceMappingURL=user-branding.component.css.map */
